import { render, staticRenderFns } from "./Judge.vue?vue&type=template&id=3548a52c"
import script from "./Judge.vue?vue&type=script&lang=ts"
export * from "./Judge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports